export const columns = [
  {
    accessorKey: "name",
    header: "Name",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "unit",
    header: "UOM",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
